import React from 'react';

import { Alert } from '@material-ui/lab';
import InfoIcon from '@material-ui/icons/Info';
import makeClasses from './styles';
import clsx from 'clsx';

const AlertWithAction = ({ type, text, actionText, onActionClick }) => {
  const classes = makeClasses();

  return (
    <Alert severity={type} icon={false} className={clsx(classes.alert, classes.alertInfo)}>
      <InfoIcon className={classes.alertIcon} />
      <div>
        {text}
        <button className={clsx(classes.alertButton, classes.alertButtonInfo)} onClick={onActionClick}>
          {actionText}
        </button>
      </div>
    </Alert>
  );
};

export default AlertWithAction;
